
import { computed, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { SpeakerData } from "@/models/events/speakers/speakerData";

export default {
  async setup() {
    const loading = ref(true);
    const router = useRouter();
    const store = useStore();
    const speakers: Array<SpeakerData> = reactive([]);
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const getMainSpeaker = (data) =>
      store.dispatch("speakers/getMainSpeaker", data);

    const fillSpeakers = (speakersData) => {
      speakers.splice(0, speakers.length);
      for (const speakerData of speakersData) {
        speakers.push(speakerData);
      }
    };
    const getSpeaker = async () => {
      loading.value = true;
      const speakerData = await getMainSpeaker({
        eventData: eventData.value.id,
      });
      fillSpeakers(speakerData);
      loading.value = false;
    };
    await getSpeaker();
    return {
      speakers,
      eventData,
      loading,
    };
  },
};
